module.exports = __webpack_public_path__ + "static/media/GreatSouthernHerald-devicecomp-min.03874931.png";